var ServerNotificationService_1;
import { __decorate } from "tslib";
import { EventEmitter, Injectable, isDevMode } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { AppConfig } from "../../../app.config";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { UrlConstants } from "../../constants/url.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
let ServerNotificationService = class ServerNotificationService {
    static { ServerNotificationService_1 = this; }
    authService;
    messageReceived = new EventEmitter();
    connectionEstablished = new EventEmitter();
    _connectionIsEstablished = false;
    _hubConnection;
    _authenticationToken;
    constructor(authService) {
        this.authService = authService;
        // TODO: implement signal R
        // this.listenForAuthenticationTokenChanges();
    }
    static buildHubUrl() {
        return AppConfig.settings.api.server + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.SIGNAL_R_HUB_SUFFIX;
    }
    static getLogLevel() {
        if (!isDevMode()) {
            return LogLevel.Debug;
        }
        else {
            return LogLevel.None;
        }
    }
    sendMessage(message) {
        this._hubConnection.invoke(SharedConstants.SEND_SERVER_MESSAGE_ACTION, message);
    }
    async setupConnection(authToken) {
        this.createConnection(authToken);
        this.registerServerEvents();
        await this.startConnection();
    }
    async listenForAuthenticationTokenChanges() {
        this.authService.$authenticationToken.subscribe(async (tokenChange) => {
            if (tokenChange && tokenChange !== "") {
                this._authenticationToken = tokenChange;
                // Need to recreate connection with new token, so close old connection first and then start new one
                await this.closeCurrentConnection();
                await this.setupConnection(this._authenticationToken);
            }
        });
    }
    createConnection(authToken) {
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(ServerNotificationService_1.buildHubUrl(), {
            accessTokenFactory() {
                return authToken;
            },
            logger: ServerNotificationService_1.getLogLevel()
        })
            // .withAutomaticReconnect()
            .build();
    }
    async startConnection() {
        try {
            await this._hubConnection.start();
            this.handleConnectionEstablished();
        }
        catch (error) {
            if (!isDevMode()) {
                throw new Error(SharedConstants.SERVER_HUB_CONNECTION_ERROR_MESSAGE + error.toLocaleString());
            }
        }
    }
    registerServerEvents() {
        this._hubConnection.on(SharedConstants.SERVER_MESSAGE_LISTENER_EVENT, (data) => {
            this.messageReceived.emit(data);
        });
    }
    handleConnectionEstablished() {
        this._connectionIsEstablished = true;
        this.connectionEstablished.emit(true);
    }
    closeCurrentConnection() {
        if (this.isConnectionActive()) {
            return this._hubConnection.stop();
        }
    }
    isConnectionActive() {
        return !!this._hubConnection;
    }
    static ctorParameters = () => [
        { type: AuthService }
    ];
};
ServerNotificationService = ServerNotificationService_1 = __decorate([
    Injectable({
        providedIn: "root"
    })
], ServerNotificationService);
export { ServerNotificationService };
